import React from 'react';
import FormattedNumber from 'components/FormattedNumber';
import HighlightedText from 'components/HighlightedText';
import { TREE_PADDING, COLORS } from '../../constants';
import {
  getArchivedTextColor,
  getNonArchivedTextColor,
  pluralize
} from '../../helpers';
import ArchivedLabel from '../ArchivedLabel';
import TreeItemWrapper from '../TreeItemWrapper';

interface FarmTreeItemProps {
  name: string;
  isArchived: boolean;
  fieldCount: number;
  totalAcres: number;
  onClick: () => void;
  paddingClass?: string;
  searchTerm?: string;
}

const FarmTreeItem: React.FC<FarmTreeItemProps> = ({
  name,
  isArchived,
  fieldCount,
  totalAcres,
  onClick,
  paddingClass = TREE_PADDING.FARM,
  searchTerm = ''
}) => {
  return (
    <TreeItemWrapper paddingClass={paddingClass} onClick={onClick}>
      <div className="flex items-center">
        <HighlightedText
          text={name}
          searchTerm={searchTerm}
          className="font-medium leading-5 truncate"
          style={{
            marginRight: isArchived ? '4px' : '0',
            color: isArchived ? COLORS.ARCHIVED_TEXT : undefined,
            display: 'block'
          }}
        />
        {isArchived && <ArchivedLabel />}
      </div>
      <p
        className="mt-2px text-xs leading-3"
        style={{
          color: isArchived ? getArchivedTextColor() : getNonArchivedTextColor()
        }}
      >
        {fieldCount} {pluralize(fieldCount, 'field')} ·{' '}
        <FormattedNumber roundedTo={2}>{totalAcres}</FormattedNumber> ac
      </p>
    </TreeItemWrapper>
  );
};

export default FarmTreeItem;
